export default "__VITE_ASSET__BgMD37yy__"